import { disconnect } from '../../../actions/integration/methods/disconnect'
import { useAssetStore } from '@/stores/asset'

/**
 * Disconnects an integration
 * @param {number} platformId - ID of the platform to disconnect
 * @param {Array} integrations - Array of integration objects to update
 * @returns {Promise<Object>} Result object with success status and integration name
 */
export const disconnectIntegration = async (platformId, integrations) => {
  const assetStore = useAssetStore()
  const integration = integrations.find(i => i.id === platformId)
  
  if (!integration) {
    return { success: false, name: 'Unknown' }
  }
  
  try {
    await disconnect(assetStore.assetId, platformId)
    
    // Update integration status
    integration.connected = false
    
    return { 
      success: true, 
      name: integration.name 
    }
  } catch (error) {
    console.error('Error disconnecting integration:', error)
    return { 
      success: false, 
      name: integration.name 
    }
  }
}
